export default function initializeSearch() {
    document.querySelectorAll('.block-search').forEach(function (block) {
        new SearchClass(block);
    });
}

class SearchClass {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        var custom_search_input = document.getElementById('custom-search-input');
        var custom_search_form = document.getElementById('custom-search-form');
        var custom_search_submit = document.getElementById('custom-search-submit');

        if (custom_search_input && custom_search_form && custom_search_submit) {
            custom_search_input.addEventListener('blur', function() {
                if (custom_search_input.value.trim() !== '') {
                    custom_search_form.submit();
                }
            });
            custom_search_submit.addEventListener('click', function() {
                custom_search_form.submit();
            });
        }
    }
}
